var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasCorrectConfig)?_c('ui-panel',[_c('domain-ui-heat-consumption',{attrs:{"tree-node-id":_vm.treeNodeId,"period":_vm.period,"filter-strategy":'ANCESTOR_OR_SELF',"has-custom-wrapper":true}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }